import { Components } from "@thisgorilla/primate-ds";
import { useState } from "react";
import styled from "styled-components";

import CommentList from "../..";
import { API_CALLS } from "../../../../../API/api_calls";
import { CommentsProps } from "../../../../../redux/slices/comments/comments";
import { UpvoteDownvote } from "../../../../Common";
import PostCommentField from "../../../PostCommentField";
import { FlexColumn, FlexRow } from "../../../Styles";
import { CommentProps } from "../Comment";

const CommentFooter = ({
  showReplyButton,
  id,
  likes,
  dislikes,
  replies = [],
  parent_comment_id,
  user_voted,
  observeCount,
  user_id,
  post_id,
  scrollAreaId,
}: CommentProps.CommentFooter) => {
  const [isButtonShow, setIsButtonShow] = useState(true);
  const [isCommentShow, setIsCommentShow] = useState(false);

  const handleVote = (voteType: Omit<CommentsProps.UserVoted, "">) => {
    if (user_voted === voteType) {
      API_CALLS.COMMENTS.removeLikeOrDislikeFromAComment({
        comment_id: id,
        parent_comment_id,
        post_id,
      });
      return;
    }

    if (voteType === "like")
      API_CALLS.COMMENTS.likeAComment({
        comment_id: id,
        parent_comment_id,
        post_id,
      });
    if (voteType === "dislike")
      API_CALLS.COMMENTS.dislikeAComment({
        comment_id: id,
        parent_comment_id,
        post_id,
      });
  };

  return (
    <>
      <Container $gapInPx={16}>
        <UpvoteDownvote
          userVoted={user_voted !== ""}
          upvoteCount={likes}
          downvoteCount={dislikes}
          downVoteHandler={() => handleVote("dislike")}
          upVoteHandler={() => handleVote("like")}
        />

        {showReplyButton ? (
          <Components.Button
            iconPosition="left"
            iconType="MessageCircle"
            kind="Tertiary"
            color="Primary"
            size="Small"
            disabled={false}
            label={String(replies.length)}
            onClick={() => setIsCommentShow(!isCommentShow)}
          />
        ) : (
          <Components.IconButton
            kind="Tertiary"
            onClick={() => setIsCommentShow(!isCommentShow)}
            iconType="MessageCircle"
            size="Small"
            disabled={false}
          />
        )}
      </Container>
      {(replies.length > 0 || isCommentShow) && (
        <Wrapper $gapInPx={10} $topPadding={isButtonShow ? 8 : 24}>
          {isCommentShow && (
            <PostCommentField
              parent_comment_id={parent_comment_id || id}
              value={`<span>{{ @user:${user_id} }}</span>`}
              post_id={post_id}
              onClose={() => setIsCommentShow(false)}
              scrollAreaId={scrollAreaId}
            />
          )}
          {replies.length > 0 && (
            <CommentList
              showReplyButton={false}
              comments={replies}
              observeCount={observeCount}
              isButtonShow={isButtonShow}
              setIsButtonShow={setIsButtonShow}
              scrollAreaId={scrollAreaId}
            />
          )}
        </Wrapper>
      )}
    </>
  );
};

export default CommentFooter;

const Container = styled(FlexRow)`
  padding-left: ${({ theme }) => theme.spacing["spacing-9"].value}rem;
`;

const Wrapper = styled(FlexColumn)<{ $topPadding: number }>`
  padding-left: ${({ theme }) => theme.spacing["spacing-9"].value}rem;
  padding-top: ${({ $topPadding }) => $topPadding}px;
`;
